// ColorPicker/index.js
import ColorPicker from './ColorPicker';
export default ColorPicker;
